import { Link } from "react-router-dom";
import SmartImage from "@/components/base/SmartImage";

const categories = [
  {
    slug: "outerwear",
    name: "Outerwear",
    img: "https://storage.helloreaddy.io/project_files/e02ced6d-98bc-4ba1-a643-ca5b440d11d8/9d1bccda-0335-4f01-9a13-ff933ab616a9_compressed_home-category-outerwear-charcoal-web.webp",
    pos: "object-center",
  },
  {
    slug: "footwear",
    name: "Footwear",
    img: "https://storage.helloreaddy.io/project_files/e02ced6d-98bc-4ba1-a643-ca5b440d11d8/8da94d55-03d8-4925-a3e3-9cdeb1aa7597_compressed_home-category-footwear-web.webp",
    pos: "object-center",
  },
  {
    slug: "packs",
    name: "Packs",
    img: "https://storage.helloreaddy.io/project_files/e02ced6d-98bc-4ba1-a643-ca5b440d11d8/0096c029-8100-4c56-a695-85d8e16ec4a2_compressed_home-category-packs-detail-web.webp",
    pos: "object-center",
  },
];

export default function Categories() {
  return (
    <section className="bg-background-50 pt-14 md:pt-16 pb-0">
      <div className="w-full px-5 md:px-10 mb-6 md:mb-8">
        <div className="flex items-end justify-between flex-wrap gap-4">
          <div>
            <p className="text-[10px] tracking-[0.24em] uppercase text-foreground-400 mb-2">Shop by Category</p>
            <h2 className="text-[28px] md:text-[32px] leading-[1.12] tracking-[-0.01em] text-foreground-50 font-light">
              Three categories. One system.
            </h2>
          </div>
          <Link
            to="/shop"
            className="text-[13px] text-foreground-200 hover:text-primary-400 flex items-center gap-2 cursor-pointer whitespace-nowrap border-b border-foreground-300/40 pb-1"
          >
            View all products <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>

      {/* Mobile: horizontal scroll-snap. Desktop: full-bleed 3-equal-image band */}
      <div className="flex md:grid md:grid-cols-3 w-full overflow-x-auto md:overflow-visible no-scrollbar snap-x snap-mandatory gap-3 md:gap-0 px-5 md:px-0">
        {categories.map((c) => (
          <Link key={c.name} to={`/shop/${c.slug}`} className="group relative block overflow-hidden cursor-pointer snap-start shrink-0 w-[80vw] md:w-auto">
            <div className="relative h-[58vh] md:h-[68vh] overflow-hidden bg-background-100">
              <SmartImage
                src={c.img}
                alt={c.name}
                tone="dark"
                imgClassName={`w-full h-full object-cover ${c.pos} group-hover:scale-[1.03] transition-transform duration-[1400ms] ease-out`}
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/55 via-black/5 to-transparent"></div>
              <div className="absolute bottom-0 left-0 p-5 md:p-6 flex items-center gap-3">
                <h3 className="text-[16px] md:text-[17px] text-foreground-50 font-normal">{c.name}</h3>
                <span className="text-foreground-50/85 group-hover:translate-x-1 transition text-[15px]">
                  <i className="ri-arrow-right-line"></i>
                </span>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}